import React from "react";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { useTranslate } from "react-polyglot";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";

// Стили аватара и маркера онлайн такие же, как в ChatListItem
const useStyles = makeStyles(
  (theme) => ({
    avatar: {
      width: 40,
      height: 40,
      border: `2px solid ${theme.palette.borderColor.main}`,
    },
    onlineMarker: {
      position: "absolute",
      right: 0,
      bottom: 0,
      width: 11,
      height: 11,
      borderRadius: "50%",
      backgroundColor: theme.palette.success.main,
      border: "2px solid white",
    },
    nameCell: {
      minWidth: 150,
    },
    tableRow: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
  { name: "EmployeeDialog" },
);

/**
 * Диалог выбора сотрудника (преподавателя)
 * @param {{open:boolean,onClose:Function,employees:Employee[]}} props
 */
const EmployeeDialog = ({ open, onClose, employees }) => {
  const classes = useStyles();
  const t = useTranslate();
  const { setSelectedEmployee } = useChat();

  /**
   * Обработчик выбора сотрудника из таблицы.
   * @param {Employee} employee выбранный сотрудник
   */
  const handleSelect = (employee) => {
    setSelectedEmployee(employee.id);
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("chat.startDialogTitle")}</DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell className={classes.nameCell}>{t("name")}</TableCell>
              <TableCell>{t("chat.jobTitle")}</TableCell>
              <TableCell>{t("chat.status")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((emp) => {
              const avatarSrc = emp.photo?.url;
              return (
                <TableRow key={emp.id} hover className={classes.tableRow} onClick={() => handleSelect(emp)}>
                  <TableCell>
                    <Box position="relative" display="inline-block">
                      <Avatar src={avatarSrc} className={classes.avatar} />
                      {emp.online && <Box className={classes.onlineMarker} />}
                    </Box>
                  </TableCell>
                  <TableCell>{emp.name}</TableCell>
                  <TableCell>{emp.jobTitle || ""}</TableCell>
                  <TableCell>{emp.online ? t("online") : t("offline")}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

EmployeeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
};

export default EmployeeDialog;
